import FormSubmitButton from '@components/LeadGenerationForm/FormComponents/FormSubmitButton';
import React from 'react';

export default function GenAICTA({ onClick }) {
  return (
    <section className="mx-auto max-w-6xl gap-6 rounded-2xl bg-v5-neutral-200 px-6 py-10 text-center  shadow-lg md:flex md:items-center md:justify-between md:px-12 md:text-left">
      <div className="mb-6 md:mb-0">
        <h2 className="font-manrope text-[24px] font-bold md:text-[40px]">
          Reinvent Your Skills,Reclaim Your Edge!
        </h2>
        <p className="mt-2 font-rubik text-[16px] font-semibold text-[#009378] md:text-[20px]">
          Learn by Doing → Lead by Knowing.
        </p>
      </div>

      <button onClick={onClick}>
        <FormSubmitButton text={'Explore Domains'} />
      </button>
    </section>
  );
}
